import { Injectable, TemplateRef } from '@angular/core';

export interface Toast {
  template: TemplateRef<any>;
  classname?: string;
  delay?: number;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toasts: any[] = [];
  private notificationAudio: HTMLAudioElement;
  constructor() {
    this.notificationAudio = new Audio('assets/sounds/notification.mp3');
    this.notificationAudio.load();
  }

  private playSound(): void {
    if (!this.notificationAudio) return;

    // rewind if already playing
    this.notificationAudio.currentTime = 0;

    this.notificationAudio.play().catch(() => {
    });
  }
  success(
    textOrTpl: string | TemplateRef<any>,
    heading: string = 'Success',
    options: any = {},
    shouldPlaySound: boolean = false
  ) {
    this.toasts.push({
      textOrTpl,
      classname: 'bg-success text-light',
      delay: 5000,
      header: heading,
      ...options,
    });
    if (shouldPlaySound) {
      this.playSound();
    }
  }

  error(
    textOrTpl: string | TemplateRef<any>,
    heading: string = 'Error',
    options: any = {},
    shouldPlaySound: boolean = false
  ) {
    this.toasts.push({
      textOrTpl,
      classname: 'bg-danger text-light',
      delay: 5000,
      header: heading,
      ...options,
    });
    if (shouldPlaySound) {
      this.playSound();
    }
  }

  warning(
    textOrTpl: string | TemplateRef<any>,
    heading: string = 'Warning',
    hideAutomatically: boolean = true,
    options: any = {},
    shouldPlaySound: boolean = false
  ) {
    this.toasts.push({
      textOrTpl,
      classname: 'bg-warning text-light',
      delay: hideAutomatically ? 5000 : null, // Use delay of 0 to keep visible
      header: heading,
      ...options,
    });
    if (shouldPlaySound) {
      this.playSound();
    }
  }


  info(
    textOrTpl: string | TemplateRef<any>,
    heading: string = 'Info',
    options: any = {},
    shouldPlaySound: boolean = false
  ) {
    this.toasts.push({
      textOrTpl,
      classname: 'bg-info text-light',
      delay: 5000,
      header: heading,
      ...options,
    });
    if (shouldPlaySound) {
      this.playSound();
    }
  }

  persistentError(
    textOrTpl: string | TemplateRef<any>,
    heading: string = 'Error',
    options: any = {},
    shouldPlaySound: boolean = false
  ) {
    this.toasts.push({
      textOrTpl,
      classname: 'bg-danger text-light',
      delay: null, // Setting delay to null to make it persistent
      header: heading,
      ...options,
    });
    if (shouldPlaySound) {
      this.playSound();
    }
  }

  remove(toast: any) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }

  clear() {
    this.toasts.splice(0, this.toasts.length);
  }

}
